import { WebAPI, AnyType } from "../constants";

type WebApiError = AnyType;

/**
 * レスポンスが致命的なエラーかどうかを判定します
 * @function isFatalErrorStatus
 * @param {number} status - レスポンスのステータス
 * @returns {boolean}} - 致命的なエラーの場合true,それ以外の場合はfalse
 */
function isFatalErrorStatus(status: number): boolean {
  const fatals = [401, 403, 404, 502];
  return fatals.find((fatal) => {
    return fatal === status;
  })
    ? true
    : false;
}

export interface ErrorResult {
  id: string | undefined;
  status: number;
}

/**
 * WebAPIで発生したエラーを解析します
 * @function getErrorStatus
 * @param {WebApiError} error - エラーオブジェクト
 * @returns {ErrorResult} - メッセージID, httpステータス
 * @description response.data.statusが致命的なエラーの場合、メッセージIDにundefinedを設定します。
 *              response.data.status === 413の場合、メッセージIDに"err_api_file_too_large"を設定します。
 *              response.dataが設定されている場合、WebAPIから受け取ったメッセージIDとhttpステータスを取得します。
 *              response.dataが設定されていない場合、メッセージIDに"err_api_system_error"を設定します。
 *              それ以外場合、メッセージIDに"err_api_system_error"、httpステータスにundefinedを設定します。
 */
export function getErrorStatus(error: WebApiError): ErrorResult {
  let status = undefined;
  if (error) {
    if (error.response) {
      console.log({ error: error });
      const response = error.response;
      if (isFatalErrorStatus(response.status)) {
        status = {
          id: undefined,
          status: response.status,
        };
      } else if (response.status === 413) {
        status = {
          id: WebAPI.ID_FILE_TOO_LARGE,
          status: response.status,
        };
      } else {
        let data = response.data;
        if (data) {
          if (response.config.responseType === "arraybuffer") {
            data = JSON.parse(
              String.fromCharCode.apply(null, new Uint8Array(data) as AnyType)
            );
            console.log(data);
          }
          if (data.error) {
            status = {
              id: data.error.id,
              status: data.error.status,
            };
          } else {
            status = {
              id: WebAPI.ID_SYSTEM_ERROR,
              status: response.status,
            };
          }
        } else {
          status = {
            id: WebAPI.ID_SYSTEM_ERROR,
            status: error.response.status,
          };
        }
      }
    } else if (error.request) {
      console.log({ error: error });
      status = { id: WebAPI.ID_SYSTEM_ERROR, status: undefined };
    } else if (error.auth) {
      console.log({ error: error });
      status = { id: error.auth.id, status: error.auth.status };
    } else {
      console.log({ error: error });
      status = { id: WebAPI.ID_SYSTEM_ERROR, status: undefined };
    }
  } else {
    console.log("error is undefined");
    status = { id: WebAPI.ID_SYSTEM_ERROR, status: undefined };
  }
  return status;
}
